/* eslint-disable indent */
elabs.LiveChatService = class {
  constructor() {
    this.onGorgiasReady((GorgiasChat) => {
      // this.addCustomStyles(GorgiasChat);

      const chatIsOpen = GorgiasChat.isOpen();
      if (chatIsOpen) {
        document.body.classList.add('el-live-chat-is-open');
      }
      GorgiasChat.on('widget:opened', () => {
        document.body.classList.add('el-live-chat-is-open');
        //this.addCustomStyles();
      });
      GorgiasChat.on('widget:closed', () => {
        document.body.classList.remove('el-live-chat-is-open');
      });

      this.initialiseOpenChatOnUrlChange();
      window.addEventListener('hashchange', () => {
        this.initialiseOpenChatOnUrlChange();
      });
    });
  }

  onGorgiasReady = (callback) => {
    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise((resolve) => {
          window.addEventListener('gorgias-widget-loaded', () => {
            resolve();
          });
        });

    initGorgiasChatPromise.then(() => {
      callback(window.GorgiasChat);
    });
  };

  initialiseOpenChatOnUrlChange = () => {
    if (window.location.hash === '#open-live-chat') {
      this.openGorgiasChat();
      // remove the hash without reloading
      history.replaceState(null, document.title, window.location.pathname + window.location.search);
    }
  };

  openGorgiasChat = () => {
    if (window.GorgiasChat) {
      window.GorgiasChat.open();
    }
  };

  // This is off for now. We can't inject font anyway, as it is on a different domain
  addCustomStyles() {
    const timer = setInterval(() => {
      const chatWindowHead = document
        .querySelector('#gorgias-chat-container')
        ?.querySelector('#chat-window')
        ?.contentWindow.document.querySelector('head');
      if (!chatWindowHead) {
        return;
      }
      if (![...chatWindowHead.children].some((x) => x.getAttribute('data-emotion'))) {
        return;
      }
      clearInterval(timer);

      document.body.style.setProperty('--main-font-family', 'Futura PT');

      const chatStyle = document.createElement('style');
      chatStyle.textContent = `:root { --main-font-family: "Futura PT"; }
        h1, h2, h3 { font-family: "Futura PT" !important; }
        body { letter-spacing: 0.3px !important; }`;

      chatWindowHead.appendChild(chatStyle);
    }, 50);
  }
};

elabs.onJavascriptReady(() => {
  elabs.LiveChatService = new elabs.LiveChatService();
});
